export const LOGIN_REDIRECT_ACTION_PREFIX = 'LOGIN_REDIRECT';
export const LOGIN_ACTION_PREFIX = 'LOGIN';
